export default __webpack_public_path__ + "static/media/falabella.47ab9a8d.c837c554.jpg";